package org.wordsapp.model

import kotlinx.serialization.Serializable

@Serializable
data class AuthStatusResponse(
    val authenticated: Boolean,
    val email: String? = null,
)

@Serializable
data class AppSessionRequest(val token: String)

@Serializable
data class WordsResponse(
    val words: List<Word>,
)

@Serializable
data class UpdateStatsRequest(
    val correctAnswers: Int,
    val incorrectAnswers: Int,
    val lastAttemptEpochMs: Long? = null,
    val streak: Int? = null,
    val easeFactor: Double? = null,
    val intervalDays: Double? = null,
)

@Serializable
data class UpdateStatsResponse(
    val success: Boolean,
    val message: String? = null,
)

@Serializable
data class SettingsRequest(
    val spreadsheetUrl: String? = null,
    val ignoreDiacritics: Boolean? = null,
)

@Serializable
data class SettingsResponse(
    val spreadsheetId: String? = null,
    val spreadsheetUrl: String? = null,
    val ignoreDiacritics: Boolean = false,
)
